// import React, { useEffect, useState } from "react";
// import { Button, Spinner } from "reactstrap";
// import { useNavigate } from "react-router-dom";
// import { AgGridReact } from "ag-grid-react";
// import { FaPlus } from "react-icons/fa";
// import { Edit, Trash2 } from "react-feather";
// import { Delete_Product, PurchaseProductList_Product } from "../../ApiEndPoint/Api";
// import { _Delete, _Get } from "../../ApiEndPoint/ApiCalling";
// import axiosConfig from "../../AxiosConfig"
// export default function Products() {
//   const navigate = useNavigate();

//   const [rowData, setRowData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // 🔥 DEMO API (mock)
//   const fetchProducts = async () => {
//     try {
//       setLoading(true);
//       const user = JSON.parse(localStorage.getItem("userData"))
//       const db = user?.database;
//       const res = await axiosConfig.get(`/product/view-product-purchase/${db}`);
//       console.log("API RES:", res);
//       debugger
//       setRowData(res?.data?.Product?.reverse() || []);
//     } catch (err) {
//       console.log("API ERROR:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchProducts();
//   }, []);

//   // 🔥 Delete (demo)
//   const handleDelete = (id) => {

//     swal("Warning", "Sure You Want to Delete it?", {
//       buttons: {
//         cancel: "Cancel",
//         delete: {
//           text: "Delete",
//           value: "delete",
//         },
//       },
//     }).then(async (value) => {

//       if (value === "delete") {

//         try {

//           const res = await _Delete(
//             Delete_Product,
//             id
//           );

//           if (res?.status) {

//             // ✅ remove from grid
//             setRowData((prev) =>
//               prev.filter(
//                 (item) => item._id !== id
//               )
//             );

//             swal(
//               "Success",
//               "Product Deleted Successfully",
//               "success"
//             );

//           } else {

//             swal(
//               "Error",
//               "Delete Failed",
//               "error"
//             );

//           }

//         } catch (err) {

//           console.log(err);

//           swal(
//             "Error",
//             "Something Went Wrong",
//             "error"
//           );
//         }
//       }
//     });
//   };
//   // 🔥 Columns
//   const columnDefs = [
//     {
//       headerName: "Warehouse ID",
//       valueGetter: (p) => p.data?.warehouse?.id,
//       cellRenderer: (params) => {
//         return (
//           <span
//             style={{
//               cursor: "pointer",
//             }}
//             onClick={() =>
//               navigate(
//                 `/production?view=edit-product-${params.data._id}`
//               )
//             }
//           >
//             {params.value}
//           </span>
//         );
//       },
//     },

//     {
//       headerName: "Product Name",
//       field: "Product_Title",
//       cellRenderer: (params) => {
//         return (
//           <span
//             style={{
//               cursor: "pointer",
//             }}
//             onClick={() =>
//               navigate(
//                 `/production?view=edit-product-${params.data._id}`
//               )
//             }
//           >
//             {params.value}
//           </span>
//         );
//       },
//     },
//     {
//       headerName: "Product saction",
//       field: "producttype",
//     },
//     {
//       headerName: "Product step",
//       field: "step_Name",
//     },
//     {
//   headerName: "MRP",
//   field: "Product_MRP",
//   valueFormatter: (params) =>
//     Number(params.value || 0).toFixed(2),
// },
//     {
//       headerName: "Min Stock",
//       field: "MIN_stockalert",
//     },
//     {
//       headerName: "Opening Stock",
//       field: "Opening_Stock",
//     },
//     {
//       headerName: "Category",
//       field: "category",
//     },
//     {
//       headerName: "SubCategory",
//       field: "SubCategory",
//     },
//     {
//       headerName: "Unit",
//       field: "primaryUnit",
//     },
//     {
//       headerName: "HSN",
//       field: "HSN_Code",
//     },
//     {
//       headerName: "GST",
//       field: "GSTRate",
//     },
//     {
//       headerName: "Status",
//       field: "status",
//     },
//     {
//       headerName: "Actions",
//       width: 120,
//       cellRenderer: (params) => (
//         <div style={{ display: "flex", gap: "8px" }}>

//           {/* Edit */}
//           <Edit
//             size={14}
//             color="blue"
//             style={{ cursor: "pointer" }}
//             onClick={() =>
//               navigate(`/production?view=edit-product-${params.data._id}`)
//             }
//           />

//           {/* Delete */}
//           <Trash2
//             size={14}
//             color="red"
//             style={{ cursor: "pointer" }}
//             onClick={() => handleDelete(params.data._id)}
//           />
//         </div>
//       ),
//     },
//   ];

//   if (loading) {
//     return (
//       <div style={{ textAlign: "center", marginTop: "100px" }}>
//         <Spinner />
//       </div>
//     );
//   }

//   return (
//     <div className="erp-page-grid">

//       {/* 🔥 Header */}
//       <div style={{ display: "flex", justifyContent: "space-between" }}>
//         <h2>Products</h2>

//         <Button
//           color="primary"
//           onClick={() =>
//             navigate("/production?view=add-product")
//           }
//         >
//           <FaPlus /> Add Product
//         </Button>
//       </div>

//       {/* 🔥 Table */}
//       <div
//         className="ag-theme-alpine"
//         style={{ height: "500px", marginTop: "10px" }}
//       >
//         <AgGridReact
//           rowData={rowData}
//           columnDefs={columnDefs}
//           pagination
//         />
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import { Button, Spinner } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import { FaPlus } from "react-icons/fa";
import { Edit, Trash2 } from "react-feather";

import {
  Delete_Product,
} from "../../ApiEndPoint/Api";

import {
  _Delete,
} from "../../ApiEndPoint/ApiCalling";

import axiosConfig from "../../AxiosConfig";

export default function Products() {
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);

  // =========================================================
  // FETCH PRODUCTS
  // =========================================================

  const fetchProducts = async () => {
    try {
      setLoading(true);

      const user = JSON.parse(
        localStorage.getItem("userData")
      );

      const db = user?.database;

      if (!db) {
        return;
      }

      const res = await axiosConfig.get(
        `/product/view-product-purchase/${db}`
      );
      console.log(
        "PRODUCT API RESPONSE =>",
        res?.data?.Product
      );
      const products =
        res?.data?.Product || [];
      // Latest first
      setRowData(
        [...products].reverse()
      );
    } catch (err) {
      console.log(
        "API ERROR =>",
        err
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  // =========================================================
  // DELETE PRODUCT
  // =========================================================

  const handleDelete = (id) => {
    swal(
      "Warning",
      "Sure You Want to Delete it?",
      {
        buttons: {
          cancel: "Cancel",

          delete: {
            text: "Delete",
            value: "delete",
          },
        },
      }
    ).then(async (value) => {
      if (value !== "delete") {
        return;
      }

      try {
        const res = await _Delete(
          Delete_Product,
          id
        );

        if (res?.status) {
          setRowData((prev) =>
            prev.filter(
              (item) =>
                item?._id !== id
            )
          );

          swal(
            "Success",
            "Product Deleted Successfully",
            "success"
          );
        } else {
          swal(
            "Error",
            "Delete Failed",
            "error"
          );
        }
      } catch (err) {
        console.log(
          "DELETE ERROR =>",
          err
        );

        swal(
          "Error",
          "Something Went Wrong",
          "error"
        );
      }
    });
  };

  const handleMultipleDelete = async () => {
    if (selectedRows.length === 0) {
      return swal(
        "Warning",
        "Please select at least one product.",
        "warning"
      );
    }

    const confirmed = await swal({
      title: "Are you sure?",
      text: `You want to delete ${selectedRows.length} selected product(s)?`,
      icon: "warning",
      buttons: ["Cancel", "Delete"],
      dangerMode: true,
    });

    if (!confirmed) return;

    setDeleteLoading(true);

    const deletedIds = [];
    const failedIds = [];

    try {
      for (const item of selectedRows) {
        try {
          const res = await _Delete(
            Delete_Product,
            item._id
          );

          if (res?.status) {
            deletedIds.push(item._id);
          } else {
            failedIds.push(item._id);
          }
        } catch (error) {
          console.error(
            `Delete failed for ${item._id}`,
            error
          );
          failedIds.push(item._id);
        }
      }

      // Remove successfully deleted products from the table
      setRowData((prev) =>
        prev.filter(
          (item) => !deletedIds.includes(item._id)
        )
      );

      setSelectedRows([]);

      if (failedIds.length === 0) {
        await swal(
          "Success",
          `${deletedIds.length} product(s) deleted successfully.`,
          "success"
        );
      } else {
        await swal(
          "Partial Success",
          `${deletedIds.length} deleted, ${failedIds.length} failed. Please try again for failed products.`,
          "warning"
        );
      }
    } finally {
      setDeleteLoading(false);
    }
  };

  // =========================================================
  // OPEN EDIT
  // =========================================================

  const openEdit = (id) => {
    navigate(
      `/production?view=edit-product-${id}`
    );
  };

  // =========================================================
  // PRODUCT NAME
  // =========================================================
  //
  // Production products me Product_Title ho sakta hai.
  // Kuch old records me Product_Title nahi hai,
  // isliye id fallback rakha hai.
  // =========================================================

  const getProductName = (data) => {
    return (
      data?.Product_Title ||
      data?.id ||
      "-"
    );
  };

  // =========================================================
  // PRODUCT SECTION
  // =========================================================

  const getProductSection = (data) => {
    if (data?.productSection) {
      return data.productSection;
    }

    // Old Trading records
    if (
      String(data?.type || "")
        .toLowerCase() === "trading"
    ) {
      return "Trading";
    }

    return "-";
  };

  // =========================================================
  // PRODUCT TYPE
  // =========================================================

 const getProductType = (data) => {
  return (
    data?.productionItemType ||
    "-"
  );
};
 const getParentchild = (data) => {
  return (
    data?.productType ||
    "-"
  );
};
  // =========================================================
  // STEPS
  // =========================================================

  const getSteps = (data) => {
    if (
      Array.isArray(data?.current_Step)
    ) {
      return data.current_Step.length > 0
        ? data.current_Step.join(", ")
        : "-";
    }

    if (data?.current_Step) {
      return data.current_Step;
    }

    return "-";
  };

  // =========================================================
  // WAREHOUSE
  // =========================================================

  const getWarehouse = (data) => {
    // New Production record
    if (
      typeof data?.warehouse ===
      "object"
    ) {
      return (
        data?.warehouse
          ?.warehouseName ||
        data?.warehouse?.id ||
        "-"
      );
    }

    // Old records where warehouse
    // can be string/id
    if (data?.warehouse) {
      return data.warehouse;
    }

    return "-";
  };

  // =========================================================
  // COLUMN DEFINITIONS
  // =========================================================

  const columnDefs = [
    // =======================================================
    // PRODUCT NAME
    // =======================================================

    {
      headerName: "Product Name",
      minWidth: 180,

      valueGetter: (params) =>
        getProductName(
          params.data
        ),

      cellRenderer: (params) => {
        return (
          <span
            style={{
              cursor: "pointer",

              fontWeight: 500,
            }}
            onClick={() =>
              openEdit(
                params.data?._id
              )
            }
          >
            {getProductName(
              params.data
            )}
          </span>
        );
      },
    },
    {
      headerName: "Warehouse",
      minWidth: 160,

      valueGetter: (params) =>
        getWarehouse(
          params.data
        ),
    },

    // =======================================================
    // PRODUCT ID
    // =======================================================

    {
      headerName: "Product ID",
      field: "id",
      minWidth: 180,
    },

    // =======================================================
    // TYPE
    // =======================================================

    {
      headerName: "Type",
      field: "type",
      minWidth: 120,
    },

    // =======================================================
    // PRODUCT SECTION
    // =======================================================

    {
      headerName: "Product Section",
      minWidth: 150,

      valueGetter: (params) =>
        getProductSection(
          params.data
        ),
    },

    // =======================================================
    // PRODUCT TYPE
    // =======================================================

    {
      headerName: "Product Type",
      minWidth: 130,

      valueGetter: (params) =>
        getProductType(
          params.data
        ),
    },
    // {
    //   headerName: "Parent/child",
    //   minWidth: 130,

    //   valueGetter: (params) =>
    //     getParentchild(
    //       params.data
    //     ),
    // },

    // =======================================================
    // WAREHOUSE
    // =======================================================



    // =======================================================
    // PRODUCT STEP
    // =======================================================

    {
      headerName: "Product Steps",
      minWidth: 180,

      valueGetter: (params) =>
        getSteps(
          params.data
        ),
    },

    // =======================================================
    // MRP
    // =======================================================

    {
      headerName: "MRP",
      field: "Product_MRP",
      minWidth: 100,

      valueFormatter: (params) =>
        Number(
          params.value || 0
        ).toFixed(2),
    },

    // =======================================================
    // PURCHASE RATE
    // =======================================================

    {
      headerName: "Purchase Rate",
      field: "Purchase_Rate",
      minWidth: 130,

      valueFormatter: (params) =>
        Number(
          params.value || 0
        ).toFixed(2),
    },

    // =======================================================
    // MIN STOCK
    // =======================================================

    {
      headerName: "Min Stock",
      field: "MIN_stockalert",
      minWidth: 110,
    },

    // =======================================================
    // OPENING STOCK
    // =======================================================

    {
      headerName: "Opening Stock",
      field: "Opening_Stock",
      minWidth: 130,
    },

    // =======================================================
    // CATEGORY
    // =======================================================

    {
      headerName: "Category",
      field: "category",
      minWidth: 130,
    },

    // =======================================================
    // SUB CATEGORY
    // =======================================================

    {
      headerName: "Sub Category",
      field: "SubCategory",
      minWidth: 140,
    },

    // =======================================================
    // UNIT
    // =======================================================

    {
      headerName: "Unit",
      field: "primaryUnit",
      minWidth: 120,
    },

    // =======================================================
    // HSN
    // =======================================================

    {
      headerName: "HSN",
      field: "HSN_Code",
      minWidth: 120,
    },

    // =======================================================
    // GST
    // =======================================================

    {
      headerName: "GST %",
      field: "GSTRate",
      minWidth: 100,

      valueFormatter: (params) =>
        Number(
          params.value || 0
        ),
    },

    // =======================================================
    // STATUS
    // =======================================================

    {
      headerName: "Status",
      field: "status",
      minWidth: 110,
    },

    // =======================================================
    // ACTIONS
    // =======================================================

    {
      headerName: "Actions",
      width: 120,

      sortable: false,
      filter: false,

      cellRenderer: (params) => (
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
          }}
        >

          {/* EDIT */}

          <Edit
            size={16}
            color="blue"
            style={{
              cursor: "pointer",
            }}
            onClick={() =>
              openEdit(
                params.data?._id
              )
            }
          />

          {/* DELETE */}

          <Trash2
            size={16}
            color="red"
            style={{
              cursor: "pointer",
            }}
            onClick={() =>
              handleDelete(
                params.data?._id
              )
            }
          />

        </div>
      ),
    },
  ];

  // =========================================================
  // LOADING
  // =========================================================

  if (loading) {
    return (
      <div
        style={{
          textAlign: "center",
          marginTop: "100px",
        }}
      >
        <Spinner />
      </div>
    );
  }

  // =========================================================
  // JSX
  // =========================================================

  return (
    <div className="erp-page-grid">

      {/* =====================================================
          HEADER
      ===================================================== */}
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "15px",
  }}
>
  <h2 style={{ margin: 0 }}>
    Products
  </h2>

  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "10px",
    }}
  >
    <Button
      color="danger"
      disabled={
        selectedRows.length === 0 || deleteLoading
      }
      onClick={handleMultipleDelete}
    >
      {deleteLoading
        ? "Deleting..."
        : `Delete Selected (${selectedRows.length})`}
    </Button>

    <Button
      color="primary"
      onClick={() =>
        navigate("/production?view=add-product")
      }
    >
      <FaPlus style={{ marginRight: "6px" }} />
      Add Product
    </Button>
  </div>
</div>

      {/* =====================================================
          TABLE
      ===================================================== */}

      <div
        className="ag-theme-alpine"
        style={{
          height: "600px",
          width: "100%",
        }}
      >



        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          pagination={true}
          paginationPageSize={20}
          animateRows={true}
          rowSelection={{
            mode: "multiRow",
            checkboxes: true,
            headerCheckbox: true,
            enableClickSelection: false,
          }}
          onSelectionChanged={(event) => {
            setSelectedRows(event.api.getSelectedRows());
          }}
          defaultColDef={{
            sortable: true,
            filter: false,
            resizable: true,
          }}
        />




      </div>

    </div>
  );
}

